import { uuid25 } from "../../../uuid/dist/uuid25.js";
import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { arrayHas } from "../../../utils/arrayHas.js";
import { SelectType } from "../editor/state.js";
import { nextPoint, nextZIndex } from "../../../utils/index.js";
import { selectAction } from "../editor/atom.actions.js";
import { addMemoAction, changeZIndexAction, removeMemoAction } from "./atom.actions.js";
import { unselectAllAction$ } from "../editor/generator.actions.js";
//#region src/engine/modules/memo/generator.actions.ts
var addMemoAction$ = () => function* ({ settings, doc: { tableIds, memoIds }, collections }) {
	const tables = query(collections).collection("tableEntities").selectByIds(tableIds);
	const memos = query(collections).collection("memoEntities").selectByIds(memoIds);
	const point = nextPoint(settings, tables, memos);
	const id = uuid25();
	yield unselectAllAction$();
	yield addMemoAction({
		id,
		ui: {
			...point,
			zIndex: nextZIndex(tables, memos)
		}
	});
	yield selectAction({ [id]: SelectType.memo });
};
var removeMemoAction$ = (id) => function* ({ doc: { memoIds }, editor: { selectedMap } }) {
	if (id) {
		yield removeMemoAction({ id });
		return;
	}
	const isInDoc = arrayHas(memoIds);
	const selectedMemos = Object.entries(selectedMap).filter(([id, type]) => type === SelectType.memo && isInDoc(id));
	for (const [id] of selectedMemos) yield removeMemoAction({ id });
};
var selectMemoAction$ = (id, $mod) => function* ({ doc: { tableIds, memoIds }, collections }) {
	const tables = query(collections).collection("tableEntities").selectByIds(tableIds);
	const memos = query(collections).collection("memoEntities").selectByIds(memoIds);
	if (!$mod) yield unselectAllAction$();
	yield selectAction({ [id]: SelectType.memo });
	yield changeZIndexAction({
		id,
		zIndex: nextZIndex(tables, memos)
	});
};
var actions$ = {
	addMemoAction$,
	removeMemoAction$,
	selectMemoAction$
};
//#endregion
export { actions$, addMemoAction$, removeMemoAction$, selectMemoAction$ };
